import { TimezoneObjectType, Currencies, AdCampaignTypeEnum, DeviceTypes } from '@shared/api/graphql/generated';
import TimezoneUtils from '@zvuk-b2b/react-uikit/toolkit/TimezoneUtils';

export {
  PHONE_NUMBER_COUNTRY_CODES,
  NEW_OFERTA_START_DATE,
  LAW_CONST,
  TARIFFS,
  OfferLinkByTariff,
} from '@shared/config';

export enum Platform {
  IOS = 'ios',
  ANDROID = 'android',
}

const PAGES_CONST = {
  LOADER_SCREEN_DELAY: 1000,
};

const GENERAL_LINK = 'https://zvuk-b2b.com/';

export const HELP_LINK = 'https://help.zvuk-b2b.com/';
export const HELP_LINK_CERTIFICATE = `${HELP_LINK}certificate`;
export const HELP_LINK_BROADCASTING = `${HELP_LINK}broadcasting#way`;
export const HELP_LINK_SLEEP_SETTINGS = 'https://help.zvuk-b2b.com/newlk#broadcasting';

export const PRIME_OFFER_LINK = `${GENERAL_LINK}sbbol_promo_offer`;

export const pointDefaultSleepSettings = [
  {
    day: 1,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 2,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 3,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 4,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 5,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 6,
    start: '09:00',
    end: '23:00',
  },
  {
    day: 7,
    start: '09:00',
    end: '23:00',
  },
];

export type TimezoneType = TimezoneObjectType;

export const ACCEPT_AUDIO_FILETYPES = {
  'audio/wav': ['.wav'],
  'audio/mpeg': ['.mp3'],
  'audio/x-aac': ['.aac'],
  'audio/x-flac': ['.flac'],
};

export const ACCEPT_VIDEO_FILETYPES = {
  'video/mpeg': ['.mp4'],
};

export const HELP_CENTER_REPORTS_LINK = 'https://help.zvuk-b2b.com/reports';

export const HELP_CENTER_VIDEO_STREAMS_LINK = 'https://help.zvuk-b2b.com/video#lk';

export const MENU_CREATOR_LINK = 'https://zvuk-b2b.com/menutv';

export const HELP_CENTER_CONTRACTS_LINK = 'https://help.zvuk-b2b.com/contracts';

export const POLKA_APPS_LINK = 'https://help.zvuk-b2b.com/polka-lk';

export const POINTS_GROUPS_HELP_CENTER_LINK = 'https://help.zvuk-b2b.com/video#lk';

export const DEFAULT_POINT_SETTINGS = {
  comment: '',
  amplifyPromo: 1,
  amplifyTrack: 1,
  amplifyInstant: 1,
  volume: 100,
  sleepMode: false,
  specialGeneration: false,
  ctype: 'aac',
  webDeviceAutocreate: true,
  sleepSettings: pointDefaultSleepSettings,
  timezone: TimezoneUtils.getCurrentTimezone(),
};

export const CURRENCIES_SIGNS = {
  [Currencies.Rub]: '₽',
  [Currencies.Gbp]: '£',
  [Currencies.Eur]: '€',
  [Currencies.Usd]: '$',
  [Currencies.Byn]: 'BYN',
};

export const INSTALL_APP_LINK =
  'https://redirect.appmetrica.yandex.com/serve/100160811351211931?source_type=web-player';

export default PAGES_CONST;

export const SEARCH_DELAY = 500;
export const FN_OPTIONS = { wait: SEARCH_DELAY };

export const PERIODICAL_AD_CAMPAIGNS = [
  AdCampaignTypeEnum.Interval,
  AdCampaignTypeEnum.Period,
  AdCampaignTypeEnum.ExactTime,
  AdCampaignTypeEnum.Groups,
];

export const DEFAULT_AD_CAMPAIGNS_TYPES = [
  AdCampaignTypeEnum.Interval,
  AdCampaignTypeEnum.Period,
  AdCampaignTypeEnum.ExactTime,
  AdCampaignTypeEnum.Instant,
  AdCampaignTypeEnum.Groups,
];

export const PLAYER_DESKTOP_TYPES = [DeviceTypes.Desktop, DeviceTypes.Desktopbox];

export const PLAYER_REAL_DEVICE_TYPES = [DeviceTypes.Androidbox, DeviceTypes.BoomSpeaker];

export const DEFAULT_PAGINATION = {
  page: 0,
  pageSize: 100,
};

export const DEFAULT_MEDIUM_PAGINATION = {
  page: 0,
  pageSize: 50,
};

export const DEFAULT_SHORT_PAGINATION = {
  page: 0,
  pageSize: 30,
};

export const DEFAULT_PAGINATION_INFO = {
  ...DEFAULT_PAGINATION,
  totalCount: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  totalPages: 0,
};

export enum PlayerSupportedFeatures {
  AdInstant = 'ad_instant',
  AudioStreamUnbindSupport = 'audio_stream_undind_support',
  OverlapResolution = 'overlap_resolution',
  VolumeControl = 'volume_control',
  VideoSupport = 'video_support',
}
